module.exports = __webpack_public_path__ + "static/img/pic.945f85bb.png";